export type CreateOrganisationModel = {
  organisation: {
    name: string;
  };
  user: {
    firstName: string;
    lastName: string;
    position: string;
  };
};

export type OrganisationModel = {
  id: string;
  name: string;
  isActive: boolean;
  integrations?: OrganisationIntegrationsModel;
};

export type OrganisationIntegrationsModel = {
  appIntegrations: AppIntegrationModel[];
};

export type AppIntegrationModel = {
  name: AvailableIntegrations;
};

export enum AvailableIntegrations {
  Mailbox = "Mail",
  Xero = "Xero",
  Dynamics = "Dynamics",
  Dynamicsfo = "DynamicsFO",
  AttelasStorage = "AttelasStorage",
  NetSuite = "NetSuite",
}
export type IntegrationResponseModel = {
  signInUrl: string;
};

export type OrganisationToneModel = {
  id: string;
  name: string;
};

export type BusinessTenant = {
  id: string;
  name: string;
  isDefault: boolean;
  documentIntegrationSource?: string;
  integrationSource?: AvailableIntegrations;
};

export type OrganisationConfigurationModel = {
  newChasablesAddToPayables: boolean;
  defaultBuisinessTenantId: string;
  isEmailContextEnabled: boolean;
  workflowEnabled: boolean;
  invoiceUploadEnabled: boolean;
  payablesApprovalEnabled: boolean;
  isDisputedEnabled: boolean;
  isInvoiceUploadEnabled: boolean;
};

export type OrganisationFileResponse = {
  id: string;
  fileName: string | null;
  displayName: string | null;
  description: string | null;
  fileExtension: string | null;
  fileSizeBytes: number;
  contentType: string | null;
  createdDate: string;
  createdByName: string | null;
};

export type OrganisationFilePaginatedResponse = {
  items: OrganisationFileResponse[];
  totalCount: number;
  pageNumber?: number | null;
  pageSize?: number | null;
};
